import { render, staticRenderFns } from "./whatsappGroupList.vue?vue&type=template&id=5183b44c"
import script from "./whatsappGroupList.vue?vue&type=script&lang=js"
export * from "./whatsappGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports